// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1CVHD","savePackageButton":"ClientWallet_savePackageButton__1-Fna"};